<template>
  <div class="c-navbar" v-if="show">
    <div class="left" @click="goBack">
      <div class="back-icon"></div>
      <div>返回</div>
    </div>
    <div class="center">
      {{ title }}
    </div>
    <div class="right">
      <span v-if="right" @click="rightBtnClick">{{ rightText }}</span>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>
<script>
  import device from '../../utils/device'

  export default {
    name: 'c-navbar',
    props: {
      rightText: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: '生意专家'
      },
      right: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        myPath: ''
      }
    },
    components: {},
    created () {
    },
    mounted () {
      this.myPath = this.$route.path
      if (device.ios) {
        // ios设置navbar
        window.muiNavbarGoBack = this.goBack.bind(this)
        window.muiNavbarRightBtnClick = this.rightBtnClick.bind(this)
        this.setNavigation()
      }
    },
    beforeDestroy () {
    },
    methods: {
      goBack () {
        let nowPath = this.$route.path
        if (nowPath === this.$cRouter.path) {
          if (!window.$bridge) return
          $bridge.navigation.popViewController() // eslint-disable-line
          return
        }
        this.$router.back()
      },
      setNavigation () {
        if (!window.$bridge) return
        $bridge.navigation.setTitle(this.title) // eslint-disable-line
        $bridge.navigation.setBackAction('javascript:muiNavbarGoBack()') // eslint-disable-line
        this.right ? $bridge.navigation.setRightButton('normal', this.rightText, 'muiNavbarRightBtnClick();') : window.$bridge.navigation.removeRightButton() // eslint-disable-line
      },
      rightBtnClick () {
        this.$emit('rbClick')
      }
    },
    computed: {
      show () {
        return device.android
      },
      routerPath () {
        return this.$route.path
      }
    },
    watch: {
      routerPath (val) {
        // 当路径再次变化为自己时，再次执行setNavigation
        if (val === this.myPath) this.setNavigation()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?1bd82910